export enum FeatureEnv {
  dev = "dev",
  stage = "stage",
  beta = "beta",
  prod = "prod",
  test = "test",
}

export enum FeatureName {
  schedule_not_rescheduled_reminder = "schedule-not-rescheduled-reminder",
  schedule_aapmpm_reminder = "schedule-aapmpm-reminder",
  referral_sms_from_crm = "referral-sms-from-crm",
  magic_link_enabled = "magic-link-enabled",
  eligibility_task_required_date_filter = "eligibility-task-required-date-filter",
  eligibility_task_prioritization_column = "eligibility-task-prioritization-column",
  eligibility_task_requested_date_filter = "eligibility-task-requested-date-filter",
  eligibility_task_sort_filter = "eligibility-task-sort-filter",
  eligibility_task_clinic_filter = "eligibility-task-clinic-filter",
}

export interface FeatureServiceOptions {
  targetEnv: string;
  baseUrl: string;
  ignoreCache?: boolean;
  rateLimitConfig?: {
    maxRequests?: number;
    perMilliseconds?: number;
    maxRPS?: number;
  };
}

export interface GetFeaturesResponse {
  environment: FeatureEnv;
  features: FeatureName[];
  values: Partial<{ [key in FeatureName]: string }>;
  source: Partial<{ [key in FeatureName]: string }>;
  options: FeatureServiceOptions;
}

export interface GetFeaturesResult extends Omit<GetFeaturesResponse, "values"> {
  values: Partial<{
    [key in FeatureName]: { enabled: boolean; clinicIds?: number[] };
  }>;
}
